import { useState, useEffect } from 'react';
import { useLanguage } from '@/i18n/LanguageContext';
import { MessageCircle } from 'lucide-react';

const SEEDED_REFLECTIONS = [
  "I realized I've been performing my whole life.",
  "The silence was louder than I expected.",
  "I named something I've been avoiding for years.",
  "I didn't know I was carrying that.",
  "The question I fear most is the one I need to answer.",
  "I wrote a letter I'll never send. It helped.",
  "Ten years ago, I was someone else entirely.",
  "My comfort lie is that I'm fine.",
  "I rehearse words I never say.",
  "The boundary I need is with myself.",
  "Someone out there remembers a version of me I've forgotten.",
  "I sat with discomfort. It wasn't as bad as running from it.",
];

const ReflectionsFeed = () => {
  const { t } = useLanguage();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    setCurrentIndex(Math.floor(Math.random() * SEEDED_REFLECTIONS.length));
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setCurrentIndex(i => (i + 1) % SEEDED_REFLECTIONS.length);
        setVisible(true);
      }, 500);
    }, 8000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="p-4 border border-border/15 bg-muted/5 rounded-xl">
      <div className="flex items-start gap-3">
        <MessageCircle className="w-3.5 h-3.5 text-muted-foreground/30 mt-1 flex-shrink-0" />
        <div className="flex-1 min-w-0">
          <p className="text-[10px] text-muted-foreground/40 uppercase tracking-wider mb-2">
            {t('anonymous_reflections') || 'Anonymous Reflections'}
          </p>
          <p className={`text-sm text-foreground/50 font-light italic transition-opacity duration-500 ${visible ? 'opacity-100' : 'opacity-0'}`}>
            "{SEEDED_REFLECTIONS[currentIndex]}"
          </p>
          <p className="text-[10px] text-muted-foreground/20 mt-2">
            — {t('anonymous_visitor') || 'a visitor'}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ReflectionsFeed;
